import React from "react";
import PropTypes from "prop-types";
import { Chip } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const CHIP_FONT = { fontFamily: "'Poppins', sans-serif", fontSize: "0.68rem" };

const STATUS_MAP = {
  completed: {
    label: "Completed",
    color: "success",
    variant: "filled",
    Icon: CheckCircleOutlineIcon,
  },
  in_progress: {
    label: "Processing",
    color: "warning",
    variant: "filled",
    Icon: HourglassEmptyIcon,
  },
  started: {
    label: "Processing",
    color: "warning",
    variant: "filled",
    Icon: HourglassEmptyIcon,
  },
  failed: {
    label: "Failed",
    color: "error",
    variant: "filled",
    Icon: ErrorOutlineIcon,
  },
  deleted: {
    label: "Deleted",
    color: "default",
    variant: "outlined",
    Icon: DeleteOutlineIcon,
  },
  not_processed: {
    label: "Not Processed",
    color: "error",
    variant: "outlined",
    Icon: ErrorOutlineIcon,
  },
};

const FALLBACK = {
  label: "Unknown",
  color: "default",
  variant: "outlined",
  Icon: HelpOutlineIcon,
};

/**
 * Reusable status chip for SharePoint file processing states.
 *
 * @param {{ status: string, size?: "small"|"medium" }} props
 */
const FileStatusChip = ({ status, size = "small" }) => {
  const cfg = STATUS_MAP[status] || FALLBACK;
  const { label, color, variant, Icon } = cfg;

  return (
    <Chip
      icon={<Icon sx={{ fontSize: "14px !important" }} />}
      label={label}
      size={size}
      color={color}
      variant={variant}
      sx={CHIP_FONT}
    />
  );
};

FileStatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "medium"]),
};

export default FileStatusChip;
